export const validateMobileNumber = (phoneNumber) => {
    return /^[0-9]{8}$/.test(phoneNumber)
}

export const validateEmail = (email) => {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}